var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiEnginesC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.25px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 12.03,
    cy: 10.41,
    rx: 1.52,
    ry: 1.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.13,
    cy: 16.83,
    r: 3.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 17.26,
    cy: 14.88,
    r: 2.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 18.54,
    y1: 10.93,
    x2: 18.27,
    y2: 12.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.81,
    y1: 6.58,
    x2: 14.14,
    y2: 6.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.51,
    y1: 13.54,
    x2: 5.51,
    y2: 10.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.67,
    y1: 20.08,
    x2: 7.67,
    y2: 20.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.57,
    y1: 19.52,
    x2: 10.57,
    y2: 20.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.46,
    y1: 19.52,
    x2: 13.46,
    y2: 20.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.36,
    y1: 19.53,
    x2: 16.36,
    y2: 20.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "14.36 6.58 15.78 5.16 19.93 9.31 18.58 10.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.46,6.12l-2.49-2.49c-.68-.68-1.76-.73-2.5-.11l-1.26,1.06,5.3,5.3,1.06-1.26c.62-.74.57-1.82-.11-2.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5.5 10.73 4.07 9.31 8.22 5.16 9.66 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.03,3.63l-2.49,2.49c-.68.68-.73,1.76-.11,2.5l1.06,1.26,5.3-5.3-1.26-1.06c-.74-.62-1.82-.57-2.5.11Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7.13,
    y1: 16.83,
    x2: 7.13,
    y2: 16.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.31,
    y1: 14.88,
    x2: 17.31,
    y2: 14.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.38,
    y1: 18.28,
    x2: 15.54,
    y2: 13.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 5.88,
    y1: 13.54,
    x2: 10.95,
    y2: 9.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 12.59,
    y1: 8.98,
    x2: 18.09,
    y2: 12.13
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEnginesC);
export default __webpack_public_path__ + "static/media/AIEngines-C.a38841a545cc49d6837c69c8c16c26a0.svg";
export { ForwardRef as ReactComponent };